import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductCreditCardConfig } from '../@types/context/product-credit-card-config.types';
import type { ProductSecuredLoanConfig } from '../@types/context/product-secured-loan-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoNoConfig } from './presets/contact-axo-no.config';
import { creditCardNoConfig } from './presets/credit-card-no.config';
import { globalNo } from './presets/global-no.config';
import { insuranceMypageNo } from './presets/insurance-mypage.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { organisationAxoNoConfig } from './presets/organisation-axo-no.config';
import { productConfigNo } from './presets/product-config.preset';
import { securedLoanCaseConfig } from './presets/secured-loan-case.config';
import { securedLoanNoConfig } from './presets/secured-loan-no.config';
import { serviceTrustpilotAxoConfig } from './presets/service-trustpilot-axo.config';
import { serviceVwoUscoreConfig } from './presets/service-vwo-uscore.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansNoConfig } from './presets/unsecured-loans-no.config';

export const global: GlobalConfig = {
  brand: 'uscore.no',
  ...globalNo,
};

export const site: SiteConfig = {
  domain: 'uscore.no',
  name: 'uScore',
  theme: {
    name: 'uscore-light',
    brand: 'uscore.no',
  },
  path: {
    loansApply: '/soknad/lan',
    securedLoansApply: '/soknad/lan-med-sikkerhet',
    securedLoansBookCall: '/soknad/lan-med-sikkerhet/bestill-samtale',
    securedLoansMypage: '/mine-tilbud/lan-med-sikkerhet',
    mypage: '/mine-tilbud',
    mypageOverview: '/mine-tilbud',
    mypageLoans: '/mine-tilbud/forbrukslan',
    mypageCreditCards: '/mine-tilbud/kredittkort',
    mypageSecuredLoans: '/mine-tilbud/lan-med-sikkerhet',
    creditCard: '/kredittkort/sok',
    // one-form only reachable via credit-card journey — loans stay on legacy
    // `/soknad/lan` (broker custom fields), hence credit-card apply slug
    oneFormPreflight: '/soknad/forhandssjekk',
    oneFormApply: '/kredittkort/soknad',
    oneFormRecommendations: '/soknad/lan/anbefalinger',
    insurance: '/soknad/forsikring',
    ...insuranceMypageNo,
  },
  ...organisationAxoNoConfig,
  ...contactAxoNoConfig,
  services: {
    cms: {
      provider: 'prepr',
    },
    trustpilot: {
      ...serviceTrustpilotAxoConfig,
      businessUnitId: '655392f86f1096327e38eeb6',
      showInForms: true,
    },
    gtm: 'GTM-MMJ8P92Z',
    ga: 'G-598Y2XNJF6',
    gtmScriptStrategy: 'lazyOnload',
    launchDarkly: {
      enabled: false,
    },
    cookieConsentManager: {
      provider: 'usercentrics',
      usercentrics: {
        settingsId: 'NqAgIJI085tXD5',
        crossDomainBridgeScriptStrategy: 'lazyOnload',
        autoBlockerScriptStrategy: 'lazyOnload',
        usercentricsScriptStrategy: 'lazyOnload',
      },
    },
    ...serviceVwoUscoreConfig,
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansNoConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const productCreditCard: ProductCreditCardConfig = {
  ...creditCardNoConfig,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: false,
    isCreditCardRecommendedVisible: false,
    ...myPageOffersConfig,
  },
};

export const productSecuredLoan: ProductSecuredLoanConfig = {
  ...securedLoanNoConfig,
  ...securedLoanCaseConfig,
};

export const product: ProductConfig = productConfigNo;
